import React from "react";
// import specific_location_img from "../../images/hyderabad.jpg";
import { useNavigate } from "react-router-dom";
import ChatButton from "../../components/ChatButton";
import { APP_NAME } from "../../Utils/constant";
import { handleApplyNow } from "../../Utils/navigation";

const Hyderabad = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="content_page_wrapper">
        <div className="content_page_banner_wrapper hyderabad_banner">
          <div className="content_page_banner_wrapper_overlay">
            <h2>Location - Hyderababad</h2>
          </div>
        </div>

        <div className="text_content_wrapper">
          <div className="text_content">
            {/* <div className="content_banner">
                <img src={specific_location_img} alt="" />
              </div> */}
            <h1 className="page_title mt30 mb20">Explore Opportunities: Instant Personal Loans in Hyderabad for Every Need</h1>
            {/* <h3>Get an Instant Personal Loan in Hyderabad</h3> */}
            <p className="mt6">
            We all know that Hyderabad is world-famous for its Biryani. However, do you know this city boasts of serving 140 varieties of Biryani to food lovers on their plates? Likewise, {APP_NAME}, the best borrow money app in India, offers a wide range of instant personal loans online, including instant personal loans online for salaried professionals, emergency personal loans, instant small personal loans, long-term loans, and many more to loan seekers in Hyderabad. 
            </p><br/>
            <p>Secondly, Hyderabad is also a hub for information technology, biotechnology, and pharmaceuticals apart from being a Biryani hub. The financial landscape of this city is dynamic and competitive. Therefore, individuals seek funds to fuel their dreams or navigate their expenses. Keeping this in mind, we have expanded our instant personal loan NBFC services in Hyderabad so that you can avail of instant funds whenever you need to meet your financial aspirations.</p>
            <br />
            <h3>Where Do You Apply for Personal Loans in Hyderabad, India?</h3>
            <p>In case you are seeking a genuine payday advance app, {APP_NAME} is a name second to none. We offer instant personal loans online catering to your financial or emergency needs. Whatever your financial need is — whether you have to pay your kids’ school fees or you have to pay your college fees before the semester exam, whether you have to pay medical bills on an urgent basis or your credit card due date is inching closure, whether you are eyeing to spend on home renovation or you are planning to surprise your family with a tour — SalalryOnTime has got you covered. <br/><br/>

Download the {APP_NAME} app now to apply and get an instant personal loan in minutes. Alternatively, you can also visit our website https://snappaisa.com/ to apply for an instant personal loan online now.</p>
<h3>Necessary Documents Required Before Instant Personal Loan Apply</h3>
<p>Here is a list of documents required before you instantly apply for a personal loan:</p>
<h4>1. Identity Proof</h4>
<p>Identity proof authenticates your identity and confirms your legal status. Acceptable documents include:</p>
            <ul className="content_list mt6">
              <li><b>Aadhaar Card:</b> A government-issued unique identification number that includes biometric data.</li>
              <li><b>Voter ID:</b> An identification card issued to citizens eligible to vote in elections.
              </li>
              <li><b>Passport:</b> A government-issued document for international travel that also serves as identity proof.</li>
              <li><b>Driver’s License:</b> A valid driving license can also be used as identity proof.</li>
            </ul>
            <br />
            <h4>2. Address Proof</h4>
            <p>Address proof establishes your residence and is essential for communication purposes. Acceptable documents include:</p>
            <ul className="content_list mt6">
              <li><b>Utility Bills:</b> Recent electricity, water, or gas bills with your name and address.</li>
              <li><b>Aadhaar Card:</b> It can also serve as address proof if it contains your current address.</li>
              <li><b>Rental Agreement:</b>  A registered lease agreement if you are renting your accommodation.</li>
              <li><b>Bank Statement:</b> A bank statement showing your name and address, typically from the last three months</li>
            </ul>
            <h4>3. Income Proof</h4>
            <p>Income proof helps us evaluate your repayment capacity. Depending on your employment status, acceptable documents include:</p>
            <ul className="content_list mt6">
              <li>Salaried Individuals:</li>
              <ul className="content_list mt6">
                <li>Salary slips for the last three months.
                </li>
                <li>Bank statements showing salary credits for the last six months.</li>
              </ul>
            </ul>
            <h4>4. PAN Card and Passport-sized Photographs</h4>
           
            <div className="button_container flex justify-center mt30">
              <button onClick={() => handleApplyNow(navigate)} className="button_container Link">Apply Now</button>
            </div>
          </div>
        </div>
      </div>
      <ChatButton />
    </>
  );
};

export default Hyderabad;
